import React from "react";
import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

const NfeKeyInput = ({
  nfeKey,
  onChange,
  onSubmit,
  inputRef,
  invoiceLoading,
  onOpenScanner,
  StyledTextField,
  ActionButton,
}) => (
  <Box component="form" onSubmit={onSubmit} sx={{ width: "100%" }}>
    <Typography
      variant={{ xs: "subtitle1", md: "h6" }}
      sx={{
        mb: { xs: 1.5, md: 2 },
        fontWeight: 600,
        color: "#ff9800",
        fontSize: { xs: "1rem", md: "1.125rem" },
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        letterSpacing: "0.01em",
      }}
    >
      Chave de Acesso da NF-e
    </Typography>
    <Box
      sx={{
        display: "flex",
        gap: { xs: 1.5, md: 2 },
        width: "100%",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: { xs: 1, md: 2 },
          width: "100%",
          alignItems: "stretch",
        }}
      >
        <StyledTextField
          fullWidth
          variant="outlined"
          placeholder="Digite ou escaneie a chave de acesso da NF-e"
          value={nfeKey}
          onChange={onChange}
          sx={{ flexGrow: 1 }}
          inputRef={inputRef}
          InputProps={{
            startAdornment: (
              <Box
                component="span"
                sx={{
                  color: "action.active",
                  mr: 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <QrCodeScannerIcon fontSize="small" />
              </Box>
            ),
          }}
        />
        <IconButton
          onClick={onOpenScanner}
          sx={{
            bgcolor: "white",
            color: "#ff9800",
            border: "1px solid rgba(255, 152, 0, 0.4)",
            borderRadius: 2,
            width: { xs: 48, md: 56 },
            height: { xs: 48, md: 56 },
            minWidth: { xs: 48, md: 56 },
            transition: "all 0.2s ease-in-out",
            display: { xs: "flex", md: "none" },
            "&:hover": {
              bgcolor: "rgba(255, 152, 0, 0.1)",
              transform: "scale(1.05)",
              boxShadow: "0 2px 8px rgba(255, 152, 0, 0.2)",
            },
          }}
        >
          <QrCodeScannerIcon
            sx={{ fontSize: { xs: "1.25rem", md: "1.5rem" } }}
          />
        </IconButton>
      </Box>
      <ActionButton
        type="submit"
        variant="contained"
        disabled={invoiceLoading}
        sx={{
          minWidth: { xs: "100%", md: "120px" },
          height: { xs: 48, md: "auto" },
          fontSize: { xs: "1rem", md: "1rem" },
          fontWeight: 600,
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        }}
      >
        {invoiceLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Buscar"
        )}
      </ActionButton>
    </Box>
  </Box>
);

export default NfeKeyInput;
